import { Illustration, Modal } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import styles from './AccessDeniedModal.module.scss';

type Props = {
  isOpened: boolean;
  titleT: string;
  descT: string;
};

export const AccessDeniedModal = observer(function AccessDeniedModal({ titleT, descT, isOpened }: Props) {
  const { t } = useTranslation();

  return (
    <Modal open={isOpened} className={styles.modal} onClickOutside={null} closeIcon={false}>
      <div className={styles.header}>
        <div className={styles.img}>
          <Illustration.AllowPopup />
        </div>
        <div>
          <p className={styles.title}>{t(titleT)}</p>
          <p className={styles.desc}>{t(descT)}</p>
        </div>
      </div>
    </Modal>
  );
});
